








































import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'
import SurfacePostReactionLike from 'vuecomponents/surface_post_reaction_like.vue'
import SurfacePostReactionVote from 'vuecomponents/surface_post_reaction_vote.vue'
import SurfacePostReactionStar from 'vuecomponents/surface_post_reaction_star.vue'
import SurfacePostReactionGrade from 'vuecomponents/surface_post_reaction_grade.vue'
import IntlMixin from 'vuemixins/intl_mixin'

const reaction = namespace('reaction')

@Component({
  components: {
    SurfacePostReactionLike,
    SurfacePostReactionVote,
    SurfacePostReactionStar,
    SurfacePostReactionGrade,
  },
  mixins: [IntlMixin],
})
class SurfacePostReaction extends Vue {
  @Prop() post
  @Prop() isReacting
  @Prop() isReactable
  @Prop() userId
  @Prop() reactionData
  @Prop() reactionIds
  @Prop() reactions
  @State isMobile
  @reaction.Getter maxGrade
  @reaction.Action createReaction
  @reaction.Action deleteReaction
  @reaction.Action startEditingReaction
  @reaction.Action stopEditingReaction

  get reactionType() {
    return this.reactionData.type
  }

  create(value) {
    this.createReaction({ postId: this.post.id, value })
  }

  deleteExisting() {
    this.deleteReaction({ postId: this.post.id })
  }

  edit(): void {
    if (this.isMobile) {
      this.startEditingReaction({ postId: this.post.id, left: null, top: null })
      return
    }

    const { left, bottom } = this.$el.getBoundingClientRect()
    const BOTTOM_SHADOW_ALLOWANCE = 8
    const LEFT_MARGIN = 4

    this.startEditingReaction({
      postId: this.post.id,
      dropdownLeft: left + LEFT_MARGIN,
      dropdownTop: bottom - BOTTOM_SHADOW_ALLOWANCE,
    })
  }

  stopEditing() {
    this.stopEditingReaction()
  }
}

export default SurfacePostReaction
